import { createLazyComponent } from '@muse-web/router'

export const AsyncGiftDialogContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'dialog-gift' */ './GiftDialogContainer'),
    'GiftDialogContainer',
)
